<div class="forbidden-container">
  <div class="forbidden-inner">
    <h1 class="mb-2">{{ 'FORBIDDEN.TITLE' | translate }}</h1>
    <p class="mb-5">{{ 'FORBIDDEN.TEXT' | translate }}</p>
    <button class="btn btn_primary" (click)="goBack()">{{ 'GENERAL.BACK' | translate }}</button>
  </div>
</div>
